/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
'use client'
import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'
import {
  Breadcrumbs,
  useBreadcrumbsV3,
} from '@mercadoni/sinister/dist/cjs/breadcrumbsV3'
import { getRoutingUrl } from '@mercadoni/sinister/dist/cjs/client/utils'
import {
  FilterSortDesktop,
  Filters,
  FiltersApplied,
} from '@mercadoni/sinister/dist/cjs/filters'
import { useFiltersContext } from '@mercadoni/sinister/dist/cjs/filters/context'
import Heading1 from '@mercadoni/sinister/dist/cjs/mystiqueHeading1'

import { useHydratedSSR } from '@mercadoni/sinister/dist/cjs/shared/hooks'
import Link from 'next/link'
import { memo } from 'react'
import LoadingFilterProducts from '../../../components/LoadingFilterProducts'
import categoryPathV3 from '../../../utils/categoryPathV3'
import {
  ProductsContainer,
  ProductsHeaderStyles,
  StyledCategoryDisplay,
} from './styles'

import useInteractions from '@/scenes/DynamicHome/hooks/useInteractions'
import { Carousel } from '@mercadoni/sinister/dist/cjs/shared/components' // TODO: revisar
import { useRouter } from 'next/navigation'
import Banners from './Banners'
import ProductsBody from './ProductsBody'

const CategoryDisplay = ({
  currentCategory,
  categoryBanners,
  path,
  productsLength,
  placementBeacons,
  clientModel,
  onRouterChange,
  carousels,
  isMobile,
}: any) => {
  const {
    // locale: clientLocale,
    // clientId,
    enabledAds,
    // seoConfig,
    filtersIcons,
    sortOptions,
  } = clientModel

  const { loading } = useFiltersContext()
  const hydratedSSR = useHydratedSSR()
  const { clients: copy } = getLocale() || defaultLocale
  const router = useRouter()

  const widgetInteractionLogic = useInteractions({
    clientConfig: clientModel,
    router,
  })

  const { crumbs, crumbsNamesPath } = useBreadcrumbsV3({
    data: currentCategory,
    copy: copy?.breadcrumbs,
  })

  const pathSwitchBuilder = (href: any) => {
    const goToHome = getRoutingUrl(href)
    const goToCategory = categoryPathV3({ slug: href })
    return href === '/' ? goToHome : goToCategory
  }

  const CrumbLink = ({ href, ...props }: any) => (
    <Link href={pathSwitchBuilder(href)} {...props} />
  )

  if (
    loading ||
    !hydratedSSR ||
    currentCategory?.categoryNamesPath !== crumbsNamesPath
  ) {
    return <LoadingFilterProducts isMobile={isMobile} hasBreadcrumbs />
  }

  const goToPath = onRouterChange

  const MobileTags = !isMobile && (
    <FiltersApplied
      className="category-filter-applied"
      clientConfig={clientModel}
      goToPath={goToPath}
    />
  )
  return (
    <div {...placementBeacons}>
      <StyledCategoryDisplay
        bannersLength={categoryBanners.length || enabledAds}
      >
        <div className="breadcrumbs-container">
          <Breadcrumbs crumbs={crumbs} CrumbLink={CrumbLink} />
        </div>
        <div className="grid-content">
          <div className="filters-container">
            <Filters
              isMobile={isMobile}
              className="search-filter-category"
              filtersIcons={filtersIcons}
              goToPath={goToPath}
              clientConfig={clientModel}
              sortOptionsConfig={sortOptions}
            />
          </div>
          <div style={{ minWidth: 0 }}>
            {carousels?.length > 0 ? (
              carousels.map((carousel: any) => (
                <Carousel
                  key={carousel.id}
                  interactions={widgetInteractionLogic}
                  carousel={carousel}
                />
              ))
            ) : (
              <div
                className={`banners-container ${
                  enabledAds ? 'banners-ads' : ''
                }`}
              >
                <Banners
                  currentCategory={currentCategory}
                  categoryBanners={categoryBanners}
                  path={path}
                  isMobile={isMobile}
                />
              </div>
            )}
            <ProductsHeaderStyles>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Heading1>{currentCategory.name || ''}</Heading1>
                <span className="products-length">{`(${productsLength})`}</span>
              </div>
              {!isMobile && (
                <FilterSortDesktop
                  goToPath={goToPath}
                  sortOptionsConfig={sortOptions}
                />
              )}
            </ProductsHeaderStyles>
            {MobileTags}
            <ProductsContainer>
              <ProductsBody
                products={currentCategory.products}
                category={currentCategory}
              />
            </ProductsContainer>
          </div>
        </div>
      </StyledCategoryDisplay>
    </div>
  )
}

export default memo(CategoryDisplay)
